import ReportTableSetup from './container/index';

export default ReportTableSetup;



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/index.js